import React, { createRef, useState, useRef, useEffect } from "react";
import * as d3 from "d3";

import moment from "moment";

// each charted value has a display name for tooltip
// tooltip may or may not have a charted value
// each line takes a
export default function LineChart(props) {
  const chart = useRef(null);
  let innerWidth;
  const defaultHeight = 220;
  var containerElement;
  let YOYdiff;
  // const [chartData, setChartData] = useState(props.data);
  // const [innerWidth, setInnerWidth] = useState();
  let chartData = props.data;
  // const [valueArray, setValueArray] = useState(props.valueArray);
  let valueArray = props.valueArray;
  // function getLineDiffValue(line0, lineTwo) {
  //   return line0 == null || lineTwo == null ? null : line0 - lineTwo;
  // }

  let xTicks = props.xTicks || 5;
  function getYOYdiffColor(YOY) {
    if (YOY < 0) {
      return "YOYred";
    } else {
      return "YOYgreen";
    }
  }
  function prepMaxVal(myData, myArrayOfKeys) {
    let tempArr = [];
    let tempStartVal = [];
    for (let i = 0; i < myData.length; i++) {
      // push whatever arr[j] is in the array as a key into
      for (let j = 0; j < myArrayOfKeys.length; j++) {
        if (myData[i][myArrayOfKeys[j]] !== null) {
          tempArr.push(myData[i][myArrayOfKeys[j]["dataKey"]]);
        }
      }
    }
    return tempArr;
  }

  function getMaxVal(myData, myArrayOfKeys) {
    // console.log(startVals, startValsRef);
    let tempArr = prepMaxVal(myData, myArrayOfKeys);
    let tempArrB = prepMaxVal(myData, myArrayOfKeys);

    let tempMax = tempArr.reduce((a, b) => Math.max(a, b));
    let tempMin = tempArrB.reduce((a, b) => Math.min(a, b));
    return { min: tempMin, max: tempMax };
  }

  function createChart(chartData, myArrayOfKeys, myID, numberFormatFn) {
    containerElement = chart.current;
    if (!containerElement) {
      return;
    }
    innerWidth = containerElement.clientWidth;
    if (innerWidth < 10) {
      return;
    }

    containerElement.innerHTML = "";
    let tempMinMax = getMaxVal(chartData, myArrayOfKeys);
    let minVal = tempMinMax.min;
    let maxVal = tempMinMax.max;
    // let currentMonth = getCurrentMonth();
    let margin = { top: 20, right: 56, bottom: 0, left: 8 };
    //////////////////////// Establish the reused vals and the bound functions  ////////////////////////
    let width = Math.max(0, innerWidth - margin.left - margin.right);
    let height = 300 - margin.top;
    const svgHeight = height + margin.top + margin.bottom + 40;
    let justBisect = d3.bisector(d => chartData.indexOf(d)).left;

    //////////////////////// Set the scales  ////////////////////////

    let x = d3.scaleLinear().range([0, width]);
    let y = d3.scaleLinear().range([height, 0]);

    // //////////////////////// Set the axis ////////////////////////

    let xAxis = d3
      .axisBottom(x)
      .tickFormat(function(d) {
        return chartData[d].niceDateAbbrev;
      })
      .ticks(xTicks)
      .tickPadding(6);

    let yAxis = d3
      .axisRight(y)
      .tickFormat(d => {
        return numberFormatFn(d);
      })
      .ticks(6)
      .tickPadding(6);

    // //////////////////////// Define the lines and/or areas  ////////////////////////

    // put consts of the lines into the global scope
    // defined means it can show gaps, isNan means it can have zero as a value
    function createLineConsts() {
      let myArr = [];
      myArrayOfKeys.map((val, index) => {
        myArr.push(
          d3
            .line()
            .defined(d => {
              return !Number.isNaN(d[val["dataKey"]]);
            })
            .x((d, i) => {
              return x(i);
            })
            .y(d => y(d[val["dataKey"]]))
        );
      });
      return myArr;
    }

    const lineConst = createLineConsts();

    // // //////////////////////// Define parent SVG  ////////////////////////

    const CVsvg = d3
      .select(containerElement)
      .append("svg")
      .attr("class", "line-chart-svg-container")
      .attr("id", myID)
      .attr("width", "100%")
      .attr("height", svgHeight)
      .attr("viewBox", `0 0 ${innerWidth} ${svgHeight}`)
      .attr("preserveAspectRatio", "xMidYMid meet")
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // // // //////////////////////// Loop through / sort data  ////////////////////////

    chartData.forEach(d => {
      d = +d;
    });

    // // // //////////////////////// Set the domains  ////////////////////////

    x.domain([
      parseInt(d3.min(chartData, (d, i) => i)),
      parseInt(d3.max(chartData, (d, i) => i))
    ]);
    y.domain([minVal, maxVal]);
    // y.domain([0, maxVal]);

    // // // //////////////////////// Append the lines / areas  ////////////////////////

    myArrayOfKeys.forEach((item, index) => {
      CVsvg.append("path")
        .datum(chartData)
        .attr("class", "line")
        .attr("stroke", item["color"])
        .attr("d", lineConst[index])
        .transition()
        .duration(1000);
    });

    // // // ///////////////////////  Add the X & Y Axis  ////////////////////////

    CVsvg.append("g")
      .attr("class", "yAxis")
      .attr("transform", "translate(" + width + ",0)")
      .call(yAxis);

    CVsvg.append("g")
      .attr("class", "xAxis")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis);

    // // // //////////////////////// Add Line Tracing on mouse and markers   ////////////////////////

    const lineTrace = CVsvg.append("line")
      .attr("class", "mouse-line x")
      .style("opacity", 0.5)
      .attr("y1", 0)
      .attr("y2", height);

    function createMarkers() {
      myArrayOfKeys.forEach((item, index) => {
        CVsvg.append("g")
          .attr("class", `marker${index}`)
          .append("circle")
          .attr("class", `line-marker`)
          .attr("stroke", item["marker"])
          .transition()
          .duration(500)
          .attr("r", 5);
      });
    }

    createMarkers();
    // // // //////////////////////// Tooltip  ////////////////////////

    const tooltipDiv = d3
      .select(containerElement)
      .append("div")
      .attr("class", "tooltipDiv")
      .attr("id", `${myID}Tooltip`);
    const dateContainer = tooltipDiv
      .append("div")
      .attr("class", "text-container");
    dateContainer
      .append("div")
      .attr("class", "label-style mr-1")
      .text("Date:");
    const dateText = dateContainer.append("div").attr("class", "value-text");

    function createLineDivTextConsts() {
      let myArr = [];
      myArrayOfKeys.map((val, index) => {
        myArr.push(tooltipDiv.append("div").attr("class", "text-container"));
      });
      return myArr;
    }
    const lineTextContainer = createLineDivTextConsts();

    myArrayOfKeys.forEach((item, index) => {
      lineTextContainer[index]
        .append("div")
        .attr("class", "label-style mr-1")
        .text(item["tooltipLabel"]);

      lineTextContainer[index]
        .append("div")
        .attr("class", "dash")
        .style("background-color", item["marker"]);
    });

    function createLineTextConsts() {
      let myArr = [];
      myArrayOfKeys.map((item, index) => {
        myArr.push(
          lineTextContainer[index]
            .append("div")
            .attr("class", `value-text`)
            .attr("id", `lineTextConst${myID}${index}`)
        );
      });
      return myArr;
    }
    const lineTextConsts = createLineTextConsts();
    // const YOYContainer = tooltipDiv
    //   .append("div")
    //   .attr("class", "text-container");
    // YOYContainer.append("div")
    //   .attr("class", "label-style mr-1")
    //   .text("YOY");
    // const YOYText = YOYContainer.append("div");

    // // //////////////////////// Add Rect to Capture Mouse Movements  ////////////////////////

    CVsvg.append("rect")
      .on("mouseover", () => {
        lineTrace.style("display", null);
        d3.select(`#${myID} .mouse-line`).style("opacity", "1");
        // d3.selectAll(".mouse-per-line .line-marker").style("opacity", "1");
      })
      .on("mousemove", () => {
        let xy = d3.mouse(d3.event.currentTarget);

        let x0 = x.invert(xy[0]);
        let mouseIndex = justBisect(chartData, x0, 1);
        let d0 = chartData[mouseIndex - 1];
        let d1 = chartData[mouseIndex];
        let d;
        if (d1 !== undefined) {
          d = x0 - chartData.indexOf(d0) > chartData.indexOf(d1) - x0 ? d1 : d0;
        } else {
          d = d0;
        }

        lineTrace.attr(
          "transform",
          "translate(" + x(chartData.indexOf(d)) + ",0)"
        );
        myArrayOfKeys.forEach((item, index) => {
          d3.select(`#${myID} .marker${index}`).attr(
            "transform",
            "translate(" +
              x(chartData.indexOf(d)) +
              "," +
              y(d[item["dataKey"]]) +
              ")"
          );
        });
        myArrayOfKeys.forEach((item, index) => {
          let myText =
            d[myArrayOfKeys[index]] !== null
              ? numberFormatFn(d[item["dataKey"]])
              : "";

          d3.select(`#${myID}Tooltip #lineTextConst${myID}${index}`).text(
            myText
          );
        });

        dateText.text(d.niceTime ? d.niceDate + ", " + d.niceTime : d.niceDate);

        d3.select(`#${myID} .mouse-line`).attr("y2", height);
      })
      .on("mouseleave", () => {
        d3.select(`#${myID} .mouse-line`).style("opacity", ".5");
      })
      .attr("class", "totalRect")
      .attr("fill", "none")
      .attr("x", 0)
      .attr("pointer-events", "all")
      .attr("width", width)
      .attr("transform", "translate(0,0)")
      .attr("height", height)
      .transition()
      .duration(500);

    // ////////////////////////// Set the data on load ////////////////////////

    d3.set().add(chartData[chartData.length - 1]);
    let d = chartData[chartData.length - 1];
    lineTrace.attr("transform", "translate(" + x(chartData.indexOf(d)) + ",0)");
    myArrayOfKeys.forEach((item, index) => {
      d3.select(`#${myID} .marker${index}`).attr(
        "transform",
        "translate(" +
          x(chartData.indexOf(d)) +
          "," +
          y(d[item["dataKey"]]) +
          ")"
      );
    });
    myArrayOfKeys.forEach((item, index) => {
      let myText =
        d[myArrayOfKeys[index]] !== null
          ? numberFormatFn(d[item["dataKey"]])
          : "";

      d3.select(`#${myID}Tooltip #lineTextConst${myID}${index}`).text(myText);
    });
    dateText.text(d.niceTime ? d.niceDate + ", " + d.niceTime : d.niceDate);
    // // YOYText.text(YOYdiff);
    // // YOYText.attr("class", YOYdiffColor);

    d3.select(`#${myID} .mouse-line`).attr("y2", height);
  }

  useEffect(() => {
    const node = chart.current;
    if (!node) {
      return;
    }

    let lastWidth = -1;
    const draw = () => {
      const nextWidth = node.clientWidth;
      if (nextWidth < 10) {
        return;
      }
      if (Math.abs(nextWidth - lastWidth) < 1 && lastWidth > 0) {
        return;
      }
      lastWidth = nextWidth;
      createChart(chartData, valueArray, props.myID, props.numberFormatFn);
    };

    draw();

    if (typeof ResizeObserver === "undefined") {
      return;
    }

    let frame = null;
    const observer = new ResizeObserver(() => {
      if (frame) {
        cancelAnimationFrame(frame);
      }
      frame = requestAnimationFrame(draw);
    });
    observer.observe(node);

    return () => {
      if (frame) {
        cancelAnimationFrame(frame);
      }
      observer.disconnect();
    };
  }, [props.resize, props.myID, props.xTicks, chartData, valueArray]);
  return <div className="line-chart" ref={chart}></div>;
}
